import type { ReactNode } from 'react'
import React, { useCallback, useState } from 'react'

import type { CustomTooltipProps } from '../../../core/Tooltip/Tooltip'
import { StyledButton, StyledContextualMenu } from './ContextualMenu.styles'

export interface ContextualMenuProps {
  'data-e2e'?: string
  button: React.ReactNode
  children?: ReactNode
  fallbackPlacements?: CustomTooltipProps['fallbackPlacements']
  fitContent?: boolean
  offset?: CustomTooltipProps['offset']
  placement?: CustomTooltipProps['placement']
}

const ContextualMenu = ({
  'data-e2e': dataE2e = 'contextual-menu',
  button,
  children,
  fallbackPlacements,
  fitContent,
  offset = [0, 0],
  placement = 'auto',
}: ContextualMenuProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleCloseContextualMenu = useCallback((e: any) => {
    let { target } = e

    while (target) {
      if (target.getAttribute('data-menu') === 'menu-entry') {
        setIsOpen(false)
        break
      }
      target = target.parentElement
    }
  }, [])

  return (
    <StyledContextualMenu
      data-e2e={dataE2e}
      fallbackPlacements={fallbackPlacements}
      fitContent={fitContent}
      hideArrow
      offset={offset}
      onVisibilityChange={setIsOpen}
      placement={placement}
      strategy="fixed"
      tooltip={
        <div onClick={handleCloseContextualMenu} aria-hidden>
          {children}
        </div>
      }
      trigger="click"
      variant="white"
      open={isOpen}
    >
      <StyledButton isOpen={isOpen}>{button}</StyledButton>
    </StyledContextualMenu>
  )
}

export default ContextualMenu
